import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  invoiceCharges: [],
  loading: false,
  error: null,
  pagination: {
    totalPages: 0,
    totalElements: 0,
    currentPage: 0,
    pageSize: 10,
    isLastPage: false,
    isFirstPage: true,
  },
  selectedChargesBill: null,
};

const invoicesChargesSlice = createSlice({
  name: "invoiceCharges",
  initialState,
  reducers: {
    fetchInvioceChargesStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchInvoiceChargesSuccess(state, action) {
      state.invoiceCharges = action.payload.invoiceCharges;
      state.pagination = action.payload.pagination;
      state.loading = false;
      state.error = null;
    },
    fetchInvoiceChargesFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },

    fetchInvioceChargesPDFStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchInvoiceChargesPDFSuccess(state, action) {
      state.loading = false;
      state.error = null;
    },
    fetchInvoiceChargesPDFFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },

    addInvoiceChargesStart(state) {
      state.loading = true;
      state.error = null;
    },
    addInvoiceChargesSuccess(state, action) {
      state.loading = false;
      state.invoiceCharges.unshift(action.payload);
      state.error = null;
    },
    addInvioceChargesFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    deleteInvoiceChargesStart(state) {
      state.loading = true;
      state.error = null;
    },
    deleteInvoiceChargesSuccess(state, action) {
      state.loading = false;
      state.invoiceCharges = state.invoiceCharges.filter(
        (invioce) => invioce.id !== action.payload
      );
      state.error = null;
    },
    deleteInvoiceChargesFailure(state, action) {
      state.loading = true;
      state.error = action.payload;
    },
    editInvoiceChargesStart(state) {
      state.loading = true;
      state.error = null;
    },
    editInvoiceChargesSuccess(state, action) {
      state.loading = false;
      const updatedInvoice = action.payload;
      const index = state.invoiceCharges.findIndex(
        (invicoe) => invicoe.id === updatedInvoice.id
      );
      if (index !== -1) {
        state.invoiceCharges[index] = updatedInvoice;
      }
      state.error = null;
    },
    editInvoiceChargesFailure(state, action) {
      state.loading = true;
      state.error = action.payload;
    },

    addInvoiceChargesNoteStart(state) {
      state.loading = true;
      state.error = null;
    },
    addInvoiceChargesNoteSuccess(state, action) {
      state.loading = false;
      state.error = null;
    },
    addInvioceChargesNoteFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },

    getChargesBillByIdStart(state) {
      state.loading = false;
      state.error = null;
      state.selectedChargesBill = null;
    },
    getChargesBillByIdSuccess(state, action) {
      state.loading = false;
      state.selectedChargesBill = action.payload;
      state.error = null;
    },
    getChargesBillByIdFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    resetInvoiceCharges(state) {
      state.invoiceCharges = [];
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  addInvioceChargesNoteFailure,
  addInvoiceChargesNoteSuccess,
  addInvoiceChargesNoteStart,
  fetchInvioceChargesPDFStart,
  fetchInvoiceChargesPDFSuccess,
  fetchInvoiceChargesPDFFailure,
  fetchInvioceChargesStart,
  fetchInvoiceChargesSuccess,
  fetchInvoiceChargesFailure,
  addInvoiceChargesStart,
  addInvoiceChargesSuccess,
  addInvioceChargesFailure,
  deleteInvoiceChargesStart,
  deleteInvoiceChargesSuccess,
  deleteInvoiceChargesFailure,
  editInvoiceChargesStart,
  editInvoiceChargesSuccess,
  editInvoiceChargesFailure,
  getChargesBillByIdStart,
  getChargesBillByIdSuccess,
  getChargesBillByIdFailure,
  resetInvoiceCharges,
} = invoicesChargesSlice.actions;

export default invoicesChargesSlice.reducer;
